// extracted by mini-css-extract-plugin
export default {"wrapper":"rYgKPEOAEhQsdJ5BNh7H","container":"sPBH1_AA2fibYY65sKnA","title":"KWUjR5tXscjeWLkDXZ9g","subtitle":"FX0D2hXXvBi2_8s80zNz","rollbackButton":"icEvq1_eqhAKx3UpGghQ"};